var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.isOpen,
            "close-on-click-modal": false,
            width: "70%",
            top: "80px",
            title: "Danh sách học sinh nhân sự",
            "panel-icon": "el-icon-user",
            "panel-title": "tức nhân sự",
            "panel-subtitle":
              "Chọn phòng ban và tìm kiếm nhân sự áp dụng tin tức này",
            "confirm-text": "Xác nhận",
            "cancel-text": "Hủy bỏ",
          },
          on: {
            "before-close": _vm.handleClose,
            cancel: _vm.handleClose,
            confirm: _vm.handleSaveForm,
          },
        },
        [
          _c("div", { staticClass: "body_dialog" }, [
            _c(
              "div",
              { staticClass: "esf-filter-bar" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 12, type: "flex", align: "bottom" } },
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c(
                        "div",
                        { staticClass: "esf-filter-item" },
                        [
                          _c("span", { staticClass: "esf-filter-label" }, [
                            _c("i", { staticClass: "el-icon-folder-opened" }),
                            _vm._v(" Phòng ban áp dụng"),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticClass: "esf-select",
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Chọn phòng ban",
                              },
                              on: { change: _vm.handleChangeFilter },
                              model: {
                                value: _vm.departmentsApply,
                                callback: function ($$v) {
                                  _vm.departmentsApply = $$v
                                },
                                expression: "departmentsApply",
                              },
                            },
                            _vm._l(_vm.departmentList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.departmentName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm.departmentsApply.length > 0
                      ? _c("el-col", { attrs: { span: 12 } }, [
                          _c(
                            "div",
                            { staticClass: "esf-filter-item" },
                            [
                              _c("span", { staticClass: "esf-filter-label" }, [
                                _c("i", { staticClass: "el-icon-user" }),
                                _vm._v(" Tìm kiếm nhân sự"),
                              ]),
                              _c("el-input", {
                                staticClass: "esf-input-search",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: true,
                                  placeholder: "Nhập tên nhân sự tìm kiếm...",
                                },
                                on: { clear: _vm.handleChangeFilter },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.handleChangeFilter.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "append",
                                      fn: function () {
                                        return [
                                          _c("el-button", {
                                            attrs: { icon: "el-icon-search" },
                                            on: {
                                              click: _vm.handleChangeFilter,
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1853576214
                                ),
                                model: {
                                  value: _vm.nameEmployees,
                                  callback: function ($$v) {
                                    _vm.nameEmployees = $$v
                                  },
                                  expression: "nameEmployees",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                class: [
                  "esf-list-wrapper",
                  { "no-data": _vm.employeesDataFilter.length === 0 },
                ],
              },
              [
                _vm.employeesDataFilter.length > 0
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "esf-list-header" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { indeterminate: _vm.isIndeterminate },
                              on: { change: _vm.handleCheckAllChange },
                              model: {
                                value: _vm.checkAll,
                                callback: function ($$v) {
                                  _vm.checkAll = $$v
                                },
                                expression: "checkAll",
                              },
                            },
                            [
                              _vm._v(
                                "\n              Tất cả nhân sự\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "esf-scroll-area" },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              staticClass: "esf-checkbox-grid",
                              model: {
                                value: _vm.employeeApply,
                                callback: function ($$v) {
                                  _vm.employeeApply = $$v
                                },
                                expression: "employeeApply",
                              },
                            },
                            _vm._l(
                              _vm.employeesDataFilter,
                              function (employee, index) {
                                return _c(
                                  "el-checkbox",
                                  {
                                    key: index,
                                    staticClass: "esf-checkbox-item",
                                    attrs: { label: employee.idTeacher },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "esf-employee-name" },
                                      [_vm._v(_vm._s(employee.teacherName))]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "esf-department-list" },
                                      _vm._l(
                                        employee.departmentTeacherApplyList,
                                        function (department, depIndex) {
                                          return _c(
                                            "span",
                                            {
                                              key: depIndex,
                                              staticClass: "esf-department-tag",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    department.departmentName
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _c("div", { staticClass: "esf-empty-state" }, [
                      _c("i", { staticClass: "el-icon-warning" }),
                      _c("span", [
                        _vm._v(
                          "Vui lòng chọn phòng ban để hiển thị danh sách nhân sự"
                        ),
                      ]),
                    ]),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }